import { setSignalrConnectionAction } from './redux/actions';

export const setSignalrConnection = (store) => {
//on load, set signalr connection
    store.dispatch(setSignalrConnectionAction());
}


// WEBPACK FOOTER //
// ./src/features/common/Signalr.js